import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-bootstrap";
import { Title, Box } from "../Core";
import Logo from "../Logo";

const TitleStyled = styled(Title)`
  font-size: 16px;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin-bottom: 22px;
`;

const UlStyled = styled.ul`
  color: ${({ theme }) => theme.goatColors.text };
  margin: 0;
  padding: 0;
  list-style: none;
  li {
    line-height: 2.25;
    a {
      color: ${({ theme, color }) => theme.colors[color]} !important;
      &:hover {
        text-decoration: none;
        color: ${({ theme, color }) => theme.colors.secondary} !important;
      }
    }
  }
`;


const MenuWrap = styled(Box)`
  position: relative;
`;

const LogoStyle = styled(Logo)`
  max-height: 80px;
`;

const FooterMenu = ({ isDark = true }) => {
  return (
    <>
      {/* <!-- Footer section --> */}
      <Box bg={isDark ? "dark" : "light"}>
        <Container>
          <MenuWrap
            css={`
              padding: 80px 0 60px;
            `}
          >
            <Row className="justify-content-center">
              {/*
              <Col lg="2" md="4">
                <LogoStyle white={isDark} />
              </Col>
              */}

              <Col lg="12" md="8" className="mt-5 mt-lg-0">
                <Row>
                  <Col xs="6" lg="4">
                    <div className="mb-5 mb-lg-4">
                      <TitleStyled
                        variant="card"
                        color={isDark ? "light" : "dark"}
                      >
                        About
                      </TitleStyled>
                      <UlStyled color={isDark ? "lightShade" : "darkShade"}>
                        <li>
                          <a href="#about-scrye">
                            Scrye
                          </a>
                        </li>
                        <li>
                          <a href="#the-team">
                            Team Members
                          </a>
                        </li>
                      </UlStyled>
                    </div>
                  </Col>
                  <Col xs="6" lg="4">
                    <div className="mb-5 mb-lg-4">
                      <TitleStyled
                        variant="card"
                        color={isDark ? "light" : "dark"}
                      >
                        Scan Yourself Into an NFT
                      </TitleStyled>
                      <UlStyled color={isDark ? "lightShade" : "darkShade"}>
                        <li>
                          <a href="you">
                            Mint
                          </a>
                        </li>
                        <li>
                          <a href="you">
                            How it works
                          </a>
                        </li>
                      </UlStyled>
                    </div>
                  </Col>
                  <Col xs="6" lg="4">
                    <div className="mb-5 mb-lg-4">
                      <TitleStyled
                        variant="card"
                        color={isDark ? "light" : "dark"}
                      >
                        Community
                      </TitleStyled>
                      <UlStyled color={isDark ? "lightShade" : "darkShade"}>
                        <li>
                          {/*
                          <a href="/#" target="_blank">
                            Discord
                          </a>
                          */}
                        </li>
                        <li>
                          <a href="https://twitter.com/ScryeAI" target="_blank">
                            Twitter
                          </a>
                        </li>
                      </UlStyled>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </MenuWrap>
        </Container>
      </Box>
    </>
  );
};

export default FooterMenu;
